<template>
  <div class="main">
    <h2 class="title">选择套餐</h2>
    <div class="cards">
      <pay-card v-for="item of list" :key="item.id" :list="item" @click.native="active(item.id, item.newprice)"></pay-card>
    </div>
    <div class="info">
      <h3>选择支付方式</h3>
      <div class="radios">
        <input id="alipay" type="radio" name="pay" value="alipay" @click="radios($event)">
        <label for="alipay" class="alipay"></label>
      </div>
      <h3>充值说明 : </h3>
      <p>1.暂支持支付宝</p>
      <p>2.当您的充值出现问题，或者未到帐时，请联系管理员。</p>
      <form id="tradeForm" name="tradeForm" type="post" action="https://pay.bloomworks.cn/pay/ms/pay/pcPay" method="post" target="_blank">
        <input type="text" id="projectToken" name="projectToken" v-show="false" v-model="this.projectToken"/>
        <input type="text" id="subject" name="subject" value="套餐1" v-show="false"/>
        <input type="text" id="businessNo" name="businessNo" v-show="false" v-model="this.businessNo"/>
        <input type="text" id="totalAmount" name="totalAmount" v-show="false" v-model="this.price"/>
        <input id="paymentType" name="paymentType" v-show="false" v-model="this.type"/>
        <input type="submit" class="btn" value="立即支付" @click="GoPay()"/>
      </form>
    </div>
  </div>
</template>

<script>
import PayCard from './slot/card'
export default {
  name: 'pay',
  data () {
    return {
      businessNo: '',
      price: 0,
      type: '0',
      projectToken: '',
      list: [
        {
          newprice: '1999999',
          oldprice: '25000',
          id: '001',
          active: false
        },
        {
          newprice: '2999999',
          oldprice: '55000',
          id: '002',
          active: false
        },
        {
          newprice: '3999999',
          oldprice: '105000',
          id: '003',
          active: false
        }
      ]
    }
  },
  methods: {
    active: function (id, price) {
      let list = this.list
      for (let item of list) {
        if (item.id !== id) {
          item.active = false
        }
      }
      this.price = price
    },
    pay: function () {
      // 用户登陆简单验证
      let user = localStorage.getItem('user') || -1
      if (user !== -1 && user) {
        
      }
    },
    radios: function (_dom) {
      if (_dom.toElement.value === 'wechar') {
        this.type = '2'
        this.projectToken = 'f3f0fc0b2dade784d0ddcd76b68990b0'
      } else if (_dom.toElement.value === 'alipay') {
        this.type = '1'
        this.projectToken = '46cf7903557235a0661f4c90d0bf991f'
      }
    }/* ,
    微信支付
    GoPay: function () {
      function showScanCode() {
        var settings = {url: "https://pay.bloomworks.cn/pay/ms/pay/scanPay", data: jQuery("#tradeForm").serialize()};
        ajaxRequest(settings, function (data) {
          if(data.code != 0){
              alert(data.msg);
          }
          clearScanCode();
          jQuery('#qrcode').qrcode({
            render : "canvas",
            width : 120,
            height : 120,
            text : data.data.qrCode
          });
        });
      }
      function clearScanCode() {
        jQuery('#qrcode').empty();
      }
      function ajaxRequest(settings, callback) {
        console.log(jQuery)
        var url = settings.url || "";
        var type = settings.type || "POST";
        var dataType = settings.dataType || "json";
        var contentType = settings.contentType || "application/x-www-form-urlencoded";
        var param = settings.data || "";
        jQuery.ajax({
          url: url,
          type: type,
          dataType : dataType,
          contentType: contentType,
          data: param,
          success: function (data) {
            console.log("data: ", data);
            callback(data);
          },
          error: function (xhr,status,error) {
            console.log("error: ", error);
          }
        });
      }
      ajaxRequest()
    } */
  },
  components: {
    PayCard
  },
  created () {
    function RndNum(n){
      var rnd="";
      for(var i=0;i<n;i++)
          rnd+=Math.floor(Math.random()*10);
      return rnd;
    }
    this.businessNo = RndNum(10)
  }
}
</script>

<style scoped>
.main {
  padding-bottom: 190px;
  background-color: #fafafa;
}
.title {
  font-size: 42px;
  text-align: center;
  line-height: 164px;
  transition: all .6s ease;
}
.cards {
  display: flex;
  justify-content: center;
  max-width: 1200px;
  margin: 0 auto;
}
.info {
  max-width: 1200px;
  margin: 50px auto 0;
  font-size: 100px;
  padding: 10px;
}
.info > h3 {
  font-size: .32em;
  font-weight: 700;
  color: #333333;
  line-height: 70px;
  transition: font-size .6s ease;
}
.info > p {
  font-size: .24em;
  color: #333333;
  line-height: 50px;
  transition: font-size .6s ease;
}
.radios {
  margin: 20px 0 30px 0;
}
.radios > label {
  display: inline-block;
  cursor: pointer; 
  position: relative;
  top: 8px;
  margin: 0 20px;
}
.radios > input[type=radio] {
  width: 24px;
  height: 24px;
}
.btn {
  width: 400px;
  line-height: 100px;
  text-align: center;
  background-color: #ff574e;
  font-size: .28em;
  color: #fff;
  margin: 100px auto 0;
  cursor: pointer;
  transition: all .6s ease;
  border-radius: 6px;
}
.wechar {
  width: 113px; height: 40px;
  background: url('../../../static/images/payIcons.png') -10px -70px;
}
.alipay {
  width: 103px; height: 40px;
  background: url('../../../static/images/payIcons.png') -170px -10px;
}
input[type=submit] {
  font-size: 28px;
  margin: 0 auto;
  display: block;
  margin-top: 40px;
}
@media (max-width: 1199px) {
  .main {
    padding-bottom: 100px;
  }
  .title {
    font-size: 32px;
    line-height: 132px;
  }
  .info {
    font-size: 80px;
  }
  .btn {
    width: 320px;
    line-height: 80px;
  }
}
@media screen and (max-width: 801px){
  .main {
    padding-bottom: 20px;
  }
  .title {
    font-size: 26px;
    line-height: 80px;
  }
  .cards {
    flex-flow: column nowrap;
    padding: 0 20px;
  }
  .btn {
    margin: 10px auto ;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mall/pay.vue